import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { isIOS } from 'react-device-detect'
import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
// @ts-ignore
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { withAccessDenied, withNotifications, withProgressAndErrorMessage } from '@app/hocs'
import CreateConditionSelected
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateCondition/CreateConditionSelected/CreateConditionSelected'
import CreateConditionSelectedIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateCondition/CreateConditionSelected/CreateConditionSelected'
import { AppState } from '@app/@types/store'
import { AppDispatch } from '@app/store'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? CreateConditionSelectedIOS : CreateConditionSelected

const mapStateToProps = (state: AppState) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const {
    isSaveSceneDraftPopupOpen,
    isAdditionalConditionMode,
    isAdditionalActionMode,
    sceneMode,
    sceneReviewConditionTypes,
  } = state.scenes.currentSceneCreating
  const {
    description, type, stateDescription, timeOperand, conditionDeviceName, conditionNumber, deviceStateInfo, usersInfo, dataNumber,
    triggeringDevice: {
      deviceState,
      deviceName: triggeringDeviceName,

    },
  } = state.scenes.currentSceneCreating.currentCondition
  const { isEditDraftSavePopupOpen, isEditSceneQuitPopupOpen } = state.scenes.editScene
  return {
    isMobile,
    path,
    description,
    type,
    triggeringDeviceName,
    stateDescription,
    timeOperand,
    usersInfo,
    isSaveSceneDraftPopupOpen,
    isAdditionalConditionMode,
    isAdditionalActionMode,
    sceneMode,
    isEditDraftSavePopupOpen,
    isEditSceneQuitPopupOpen,
    conditionDeviceName,
    conditionNumber,
    deviceStateInfo,
    dataNumber,
    deviceState,
    sceneReviewConditionTypes,
    initialConditions: state.scenes.currentSceneConditionsActions.conditions,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
  }
}

const mapDispatchToProps = (dispatch: AppDispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
}, dispatch)

enhance = withNotifications(enhance)
enhance = withProgressAndErrorMessage(enhance)
enhance = withAccessDenied(enhance)
// @ts-ignore
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const CreateConditionSelectedEnhanced = enhance

export default CreateConditionSelectedEnhanced
